export const FREQUENCIES = ["Manual", "Hourly", "Daily", "Weekly"];

/** Form field layout only. Not used as catalog or connector list data. */
export const CONNECTOR_FORM_SCHEMAS = [
  {
    id: "salesforce",
    name: "Salesforce",
    type: "Salesforce",
    authLabel: "OAuth 2.0 · API Token",
    authMethod: "OAuth 2.0",
    instruction: "Fields below are specific to Salesforce. Enter the credentials for the instance you want to connect.",
    fields: [
      {
        key: "instanceUrl",
        label: "Instance URL",
        placeholder: "https://yourcompany.my.salesforce.com",
      },
      { key: "clientId", label: "Client ID", placeholder: "3MVG9..." },
      { key: "clientSecret", label: "Client Secret", secret: true },
    ],
    testSummaryKeys: [
      { key: "instanceUrl", label: "Instance URL", display: "host" },
      { key: "authMethod", label: "Auth Method", static: "OAuth 2.0" },
    ],
  },
  {
    id: "hubspot",
    name: "HubSpot",
    type: "HubSpot",
    authLabel: "OAuth · API Token",
    authMethod: "OAuth",
    instruction: "Fields below are specific to HubSpot. Enter the credentials for the portal you want to connect.",
    fields: [
      { key: "hubId", label: "Hub ID", placeholder: "12345678" },
      { key: "clientId", label: "Client ID", placeholder: "xxxxxxxx-xxxx-xxxx..." },
      { key: "clientSecret", label: "Client Secret", secret: true },
    ],
    testSummaryKeys: [
      { key: "hubId", label: "Hub ID" },
      { key: "authMethod", label: "Auth Method", static: "OAuth" },
    ],
  },
  {
    id: "sap",
    name: "SAP",
    type: "SAP",
    authLabel: "Basic · OAuth2 Client Credentials",
    authMethod: "Basic",
    instruction: "Fields specific to SAP — choose an auth type.",
    fields: [
      {
        key: "baseUrl",
        label: "Base URL",
        placeholder: "https://sap.yourcompany.com/odata",
      },
      {
        key: "entitySet",
        label: "Entity Set",
        placeholder: "e.g. FinancialDocuments",
      },
      {
        key: "authType",
        label: "Auth Type",
        type: "segment",
        options: ["Basic", "OAuth2 Client Credentials"],
        defaultValue: "Basic",
      },
      {
        key: "username",
        label: "Username",
        placeholder: "sap_service_account",
        visibleWhen: { authType: "Basic" },
      },
      {
        key: "password",
        label: "Password",
        secret: true,
        visibleWhen: { authType: "Basic" },
      },
      {
        key: "clientId",
        label: "Client ID",
        placeholder: "oauth-client-id",
        visibleWhen: { authType: "OAuth2 Client Credentials" },
      },
      {
        key: "clientSecret",
        label: "Client Secret",
        secret: true,
        visibleWhen: { authType: "OAuth2 Client Credentials" },
      },
    ],
    testSummaryKeys: [
      { key: "baseUrl", label: "Base URL", display: "host" },
      { key: "authType", label: "Auth Method" },
    ],
  },
];

export function getCatalogByType(type) {
  const key = String(type || "").trim().toLowerCase();
  return (
    CONNECTOR_FORM_SCHEMAS.find(
      (c) => c.type.toLowerCase() === key || c.id.toLowerCase() === key
    ) || null
  );
}
